module.exports = __webpack_public_path__ + "static/media/G-gayakerja.bcc49fe1.svg";